import { gql } from 'graphql-request'

export const REJECT_CAMPAIGN = gql`
  mutation RejectCampaign($id: Int!) {
    rejectCampaign(id: $id) {
      message
    }
  }
`
